import React from "react";
import { useNavigate } from "react-router-dom";

export const ReportViewSelector = ({ dates, value = "live" }) => {
  const navigate = useNavigate();
  return <label className="flex flex-wrap items-center gap-3 text-xs font-semibold">Report view
    <select aria-label="Report view" data-testid="cockpit-asof" value={value} onChange={e => navigate(e.target.value === "live" ? "/" : `/?view=history&as_of=${e.target.value}`)} className="border border-slate-300 bg-white text-sm px-3 py-2 max-w-full">
      <option value="live">{"Live activity · latest available"}</option>
      {dates.map(date => <option key={date} value={date}>{`Historical portfolio · ${date}`}</option>)}
    </select>
  </label>;
};